import * as constantes from '../../constantes';
import React, { Component } from 'react';
import { Button , Container , Grid , Header, Icon , Message, Segment , Table } from 'semantic-ui-react'; 
import { Dropdown , Form , Input } from 'semantic-ui-react-form-validator';
import {Link} from 'react-router-dom'

import { useParams } from "react-router-dom";
import { DatePicketControl } from '../controls/Controles'; 
import './../../assets/eje.css';

import auth0Client from '../Auth/Auth'; 
const server = constantes.REST_API_PRIVATE;

const WrappedDatosCaso = props => {
    const params = useParams();
    return <DatosCaso id={params.id} />
}

const tabla = {
    caption : {
        'caption-side' : 'top'
    }
}

const style = {
    h1: {
      marginTop: '3em',
    },
    h2: {
      margin: '2em 0em 2em',
    },
    h3: {
      marginTop: '1em',
      padding: '1em 0em',
    },
    last: {
      marginBottom: '300px',
    },
  }

const tipoDocIdentidad = [
    { key: '1', text: 'DNI', value: '1' },
    { key: '2', text: 'RUC', value: '2' }
]

const tiposProceso= [
    { key: '1', text: 'HABEAS DATA', value: 'HD' },
    { key: '2', text: 'HABEAS CORPUS', value: 'HC' }
]

const tipoProcesoConst = [
    {
      key: '1',
      text: 'Proceso de Amparo',
      value: '1'
    },
    {
      key: '2',
      text: 'Proceso de Habeas Corpus',
      value: '2'
    },
    {
      key: '3',
      text: 'Proceso de Habeas Data',
      value: '3'
    },
    {
      key: '4',
      text: 'Proceso de Cumplimiento',
      value: '4'
    },
    {
      key: '5',
      text: 'Proceso de Inconstitucionalidad',
      value: '5'
    },
    {
      key: '6',
      text: 'Proceso Competencial',
      value: '6'
    },
]

const distritoJudicial = [
    { key: '1', value: '1' , text: 'Lima Este' },
    { key: '2', value: '2' , text: 'Lima Norte' },
    { key: '3', value: '3' , text: 'Arequipa' },
    { key: '4', value: '4' , text: 'Lima' },
    { key: '5', value: '5' , text: 'Lima Sur' },
    { key: '6', value: '6' , text: 'Lambayeque' },
    { key: '7', value: '7' , text: 'Ica' },
    { key: '8', value: '8' , text: 'La Libertad' },
    { key: '9', value: '9' , text: 'Junin' },
    { key: '10', value: '10' , text: 'Cusco' },
    { key: '11', value: '11' , text: 'Callao' },
    { key: '12', value: '12' , text: 'Sullana' },
    { key: '13', value: '13' , text: 'Huaura' },
    { key: '14', value: '14' , text: 'Cajamarca' },
    { key: '15', value: '15' , text: 'Del Santa' },
    { key: '16', value: '16' , text: 'Huanuco' },
    { key: '17', value: '17' , text: 'Piura' },
    { key: '18', value: '18' , text: 'Tacna' },
    { key: '19', value: '19' , text: 'Ventanilla' },
    { key: '20', value: '20' , text: 'Ayacucho' },
    { key: '21', value: '21' , text: 'Puno' },
    { key: '22', value: '22' , text: 'San Martin' },
    { key: '23', value: '23' , text: 'Ucayali' },
    { key: '24', value: '24' , text: 'Tumbes' },
    { key: '25', value: '25' , text: 'Loreto' },
    { key: '26', value: '26' , text: 'Moquegua' },
    { key: '27', value: '27' , text: 'Ancash' },
    { key: '28', value: '28' , text: 'Cañete' },
    { key: '29', value: '29' , text: 'Apurimac' },
    { key: '30', value: '30' , text: 'Madre de Dios' },
    { key: '31', value: '31' , text: 'Amazonas' },
    { key: '32', value: '32' , text: 'Pasco' },
    { key: '33', value: '33' , text: 'Huancavelica' },
]

const tipoNotificacion = [
    { key: '1', value: '1' , text: 'Notificación Física' },
    { key: '2', value: '2' , text: 'Notificación Electrónica' }
]

const casoEmpty = {
    "casoId" : 0,
    "nombre" : null,
    "resumen" : null,
    "fechaPresentacion" : "",
    "fechaInicioAnalisis" : "",
    "fechaFinAnalisis" : "",
    "tipoResultado" : null,
    "etapaVicioSentencia" : null,
    "etapa" : {
        "idEtapa" : 10,
        "etapa" : "INICIO"
    },
    "estado" : 1,
    "usuarioCreacion" : "1",
    "usuarioModificacion" : "",
    "fechaCreacion" : "",
    "fechaModificacion" : "",
    "tipoHabeasData" : null,
    "racPresentadoPor" : null,
    "motivosRechazoDeForma" : null,
    "resolucionRac" : null,
    "motivoAlternativaId" : null,
    "motivoPreguntaId" : null,
    "motivoPregunta" : null,
    "motivoResultAnalizado" : null,
    "flagProcedencia" : null,
    "flagVasquezRomero" : null,
    "flagAdmisibilidad" : null,
    "estadoTxt" : "INICIADO"
}

class DatosCaso extends Component {
  
    constructor(props) {
      super(props);
      this.state = {
        isLoaded: false,
        errors: [],
        error: null,
        error2: null,
        mensaje : null,
        casoId: props.id,
        casoFinal : null,
        dtFechaNotifEntidad : new Date() ,
        dtFechaDemanda : new Date() ,
        dtFechaNotifPrimeraInst : new Date() ,
        dtFechaApelacion : new Date() ,
        dtFechaNotifSegundaInst : new Date() ,
        dtFechaNotifPresentacionRAC : new Date(), 

        numeroImport : '' ,
        anioImport : '' ,
        tipoImport : 'HD' 
      };

      this._onChange = this._onChange.bind(this); 
      this._handlerChangeTextFunction = this._handlerChangeTextFunction.bind(this);
      this._handlerChangeTextCasoFunction = this._handlerChangeTextCasoFunction.bind(this);
      this.extraerCaso = this.extraerCaso.bind(this);

      this.registrarCaso = this.registrarCaso.bind(this); 
      
    }
    
    componentDidMount() {
        auth0Client.isExpired();

        console.log( 'casoId = ' + this.state.casoId );
        console.log( 'casoId !=0  = ' + (this.state.casoId !== 0 ) );

        if( this.state.casoId !== '0' ){
            this.cargarCaso( this.state.casoId );
        }else{
            this.extraerCaso();
        }
        
    }

    _onChange(e, { name, value }) {
        let METHODNAME = '_onChange - ';
        console.log(METHODNAME + 'name = ' + name + '; value = ' + value  );
 
        this.setState({
            [name]: value
        });

        console.log( METHODNAME + 'dtFechaNotifEntidad = ' +  this.state.dtFechaNotifEntidad );

    }

    _handlerChangeTextFunction( e ){
        let METHODNAME = '_handlerChangeTextFunction - ';

        let valor = e.target.value;
        let name = e.target.name;
        //console.log(METHODNAME + 'name = ' + name + ', value='+ valor );
        this.setState({
            [name]: valor
        });

    }

    _handlerChangeTextCasoFunction( e ){
        let METHODNAME = '_handlerChangeTextCasoFunction - ';

        let valor = e.target.value;
        let name = e.target.name;

        this.setState(prevState => ({
            casoFinal:{
              ...prevState.casoFinal,
              [name]: valor
            }
        }));

    }

    extraerCaso(){
        let METHODNAME = 'extraerCaso - ';
        console.log(METHODNAME + 'INI');

        this.setState({
            isLoaded: true,
            casoFinal : casoEmpty
        });

    }

    cargarCaso( idCaso ){
        let METHODNAME = 'cargarCaso - ';
        console.log(METHODNAME + 'INI');

        let url = server+`/caso/${idCaso}/`;
        fetch( 
            url , {
            method: 'GET',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            }
        })
        .then(res => res.json())
        .then(
            (result) => {
                console.log(METHODNAME + 'RESULTADO DEL CASO');
                console.log(METHODNAME + 'PRIMERA PREGUNTA = ' + result.caso.casoId  );

                this.setState({
                    isLoaded: true,
                    casoFinal : result.caso 
                });

            },
            
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        )

        console.log(METHODNAME + 'FIN');
    }
    
    importarCaso(){
        let METHODNAME = 'importarCaso - ';
        console.log(METHODNAME + 'INI');

        this.handleDismiss('error2');
        this.handleDismiss('mensaje');

        if( this.state.numeroImport === ''){
            this.setState({ error2:  'Debe ingresar un Número de Expediente para poder ser importado'  })
            return;
        }

        if( this.state.anioImport === ''){
            this.setState({ error2:  'Debe ingresar el Año del Expediente para poder ser importado'  })
            return;
        }

        let url = server+`/casos/import/`;

        let dataForm = {
            "authUsername" : localStorage.getItem('usuario'),
            "numeroExpediente" :  this.state.numeroImport,
            "anioExpediente" :  this.state.anioImport,
            "tipoExpediente" :  this.state.tipoImport,
        }

        fetch( 
            url , {
            method: 'POST',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            },
            body:JSON.stringify(dataForm)
        })
        .then(res => res.json())
        .then(
            (result) => { 

                if( result.resultado === 'true'){
                    console.log(METHODNAME + 'Importado = ' + result.caso.casoId  );

                    //AQUI tal vez debo registrar el caso en BD 
                    //cosa que cuando refresque la pantalla ya pueda recargar en base al caso que esta en BD 
                    //alert('Expediente encontrado');
    
                    this.setState({
                        isLoaded: true,
                        casoId : result.caso.casoId 
                    });

                    // llamar al metodo que carga todo de nuevo y le paso el ID 
                    // result.caso.casoId  
                    this.cargarCaso( result.caso.casoId );

                }else{
                    this.setState({
                        isLoaded: true, 
                        error2: result.error 
                    });
                }

            },
            
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        )

        console.log(METHODNAME + 'FIN');
    }

    async registrarCaso(){
        let METHODNAME = 'registrarCaso - ';
        console.log( METHODNAME + 'INI ');

        let dataForm = {
            caso : this.state.casoFinal
        }
    
        let url =  `${server}/casos/`;
    
        await fetch( url , {
            method: 'POST',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            },
            body:JSON.stringify(dataForm)
        }).then((result) => {
            result.json().then((resp) => {
    
                if( resp.resultado === 'true' ){
                    console.warn(METHODNAME +  'grabado correctamente' );
                    this.setState({ 
                        casoFinal : resp.caso,
                        mensaje : resp.mensaje
                    });
                }else{ 
                    console.warn(METHODNAME +  'No se pudo grabar la informacion, Error: ' + resp.error );
                }
    
            }).catch((error) => { 
                console.error(METHODNAME +  'Error al procesar respuesta: ' + error)
            });
    
        }).catch((error) => { 
            console.error(METHODNAME +  'Server Error: ' + error)
        });
    
    }

    handleDismiss = ( nombre ) => {

        this.setState({ [nombre]: null })

        setTimeout(() => {
            this.setState({ visible: true })
        }, 2000)
    }

    render() {
        
        const { error, error2 , mensaje , isLoaded, casoFinal } = this.state;
        
        if (error) {
            //return <div>Error: {error.message}</div>;

            return (
                <Message 
                  header='Ha ocurrido un error:'
                  content={error.message}
                />
              )

        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {
            
            return(
              
                <Container>
                
                    { error2 &&
                        <Message
                            color='red'
                            onDismiss={ () => this.handleDismiss('error2')}
                            header='Ha ocurrido un error:'
                            content={error2}
                        />
                    }

                    { mensaje &&
                        <Message
                            color='green'
                            onDismiss={ () => this.handleDismiss('mensaje')}
                            header='Resultado satisfactorio:'
                            content={mensaje}
                        />
                    }

                    { !casoFinal.casoId &&
                    
                        <Segment className='segmentTop'>

                            <Header as='h3' content='Buscar Expediente en el SIGE' className='segmentTopTitle' textAlign='center' />
                            
                            <Form autoComplete="off" >
                                <Grid container columns={5} stackable>
                                    <Grid.Column width={4}>
                                        <label style={ {'fontWeight' : 'bold'}}>Número de Expediente:</label>
                                    </Grid.Column>
                                    <Grid.Column width={3}>
                                        <Input id='numeroImport' name='numeroImport' placeholder='Número de Expediente'  maxLength="5"
                                            value={this.state.numeroImport} 
                                            onChange = {this._handlerChangeTextFunction}/>
                                    </Grid.Column>
                                    <Grid.Column width={3}>
                                        <Input id='anioImport' name='anioImport' placeholder='Año de expediente' maxLength="4"
                                            value={this.state.anioImport} 
                                            onChange = {this._handlerChangeTextFunction}/>
                                    </Grid.Column>
                                    <Grid.Column width={4}>
                                        <Dropdown
                                            placeholder='Tipo de Proceso'
                                            disabled={true}
                                            value={this.state.tipoImport} 
                                            fluid
                                            selection
                                            options={tiposProceso}
                                            /> 
                                    </Grid.Column>
                                    <Grid.Column width={1}>
                                        <Button color='green' onClick={ () => this.importarCaso() } > 
                                            Importar
                                        </Button>
                                    </Grid.Column>
                                </Grid>
                            </Form>
                        </Segment>
                   
                    }

                    <Header as='h2' content='Datos del Expediente' style={style.h2} textAlign='center' />
             
                <Form onSubmit={this.registrarCaso}>
                  
                    <Segment>

                    <Table definition color='red'>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell width={4}>Tipo de Proceso:</Table.Cell>
                                <Table.Cell width={12}>
                                    <Input id='cdesTipoproceso' name='cdesTipoproceso' placeholder='tipo de proceso' 
                                        validators={['required' , 'maxStringLength:15']} 
                                        errorMessages={['Debe ingresar el numero de expediente','No debe superar los 15 caracteres']} 
                                        value={casoFinal.cdesTipoproceso} 
                                        onChange = {this._handlerChangeTextCasoFunction} />
                                </Table.Cell> 
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}>Número de Expediente:</Table.Cell>
                                <Table.Cell width={12}>
                                    <Input id='cnumExpediente' name='cnumExpediente' placeholder='numero de Expediente' 
                                        validators={['required' , 'maxStringLength:15']} 
                                        errorMessages={['Debe ingresar el numero de expediente','No debe superar los 15 caracteres']} 
                                        value={casoFinal.cnumExpediente} 
                                        onChange = {this._handlerChangeTextCasoFunction} />
                                </Table.Cell> 
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}>Procedencia:</Table.Cell>
                                <Table.Cell width={12}>
                                    <Input id='ctxtProcedencia' name='ctxtProcedencia' placeholder='ctxtProcedencia' 
                                        value={casoFinal.ctxtProcedencia} 
                                        onChange = {this._handlerChangeTextCasoFunction}/>
                                </Table.Cell> 
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}>Des. Materia:</Table.Cell>
                                <Table.Cell width={12}>
                                    <Input id='cdesMateria' name='cdesMateria' placeholder='cdesMateria' 
                                        value={casoFinal.cdesMateria} 
                                        onChange = {this._handlerChangeTextCasoFunction}/>
                                </Table.Cell> 
                            </Table.Row>
                            <Table.Row style={{display:'none'}}>
                                <Table.Cell width={4}>Des. Submateria:</Table.Cell>
                                <Table.Cell width={12}>
                                    <Input id='cdesSubmateria' name='cdesSubmateria' placeholder='cdesSubmateria' 
                                        value={casoFinal.cdesSubmateria} 
                                        onChange = {this._handlerChangeTextCasoFunction}/>
                                </Table.Cell> 
                            </Table.Row>
                            <Table.Row style={{display:'none'}}>
                                <Table.Cell width={4}>Des. Especifica:</Table.Cell>
                                <Table.Cell width={12}>
                                    <Input id='cdesEspecifica' name='cdesEspecifica' placeholder='cdesEspecifica' 
                                        value={casoFinal.cdesEspecifica} 
                                        onChange = {this._handlerChangeTextCasoFunction}/>
                                </Table.Cell> 
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}>Fec. Notificacion sentencia 1:</Table.Cell>
                                <Table.Cell width={12}>
                                    <Input id='cfecNotsent1' name='cfecNotsent1' placeholder='cfecNotsent1' 
                                        value={casoFinal.cfecNotsent1} 
                                        onChange = {this._handlerChangeTextCasoFunction}/>
                                </Table.Cell> 
                            </Table.Row>
                            <Table.Row style={{display:'none'}}>
                                <Table.Cell width={4}>Fecha Notificacion sentencia 2:</Table.Cell>
                                <Table.Cell width={12}>
                                    <Input id='cfecNotsent2' name='cfecNotsent2' placeholder='cfecNotsent2' 
                                        value={casoFinal.cfecNotsent2} 
                                        onChange = {this._handlerChangeTextCasoFunction}/>
                                </Table.Cell> 
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}>Fec. Publicacion sentencia 1:</Table.Cell>
                                <Table.Cell width={12}>
                                    <Input id='cfecPubsent1' name='cfecPubsent1' placeholder='cfecPubsent1' 
                                        value={casoFinal.cfecPubsent1} 
                                        onChange = {this._handlerChangeTextCasoFunction}/>
                                </Table.Cell> 
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}>Fallo Primera instancia:</Table.Cell>
                                <Table.Cell width={12}>
                                    <Input id='ctxtFallo1' name='ctxtFallo1' placeholder='ctxtFallo1' 
                                        value={casoFinal.ctxtFallo1} 
                                        onChange = {this._handlerChangeTextCasoFunction}/>
                                </Table.Cell> 
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}>Fallo segunda instancia:</Table.Cell>
                                <Table.Cell width={12}>
                                    <Input id='ctxtFallo2' name='ctxtFallo2' placeholder='ctxtFallo2' 
                                        value={casoFinal.ctxtFallo2} 
                                        onChange = {this._handlerChangeTextCasoFunction}/>
                                </Table.Cell> 
                            </Table.Row>
                        </Table.Body>
                    </Table>

                    { casoFinal.involucrados && 
                     
                     <Table celled color='red'>
                         <Table.Header>
                             <Table.Row key='head0002'>
                                 <Table.HeaderCell>Condición</Table.HeaderCell> 
                                 <Table.HeaderCell>Nombres</Table.HeaderCell>
                                 <Table.HeaderCell>Tipo Documento</Table.HeaderCell>
                                 <Table.HeaderCell>Número de Documento</Table.HeaderCell>
                             </Table.Row>
                         </Table.Header>
                         <Table.Body>
                             {
                             casoFinal.involucrados.map( involucrado => (
                                 <Table.Row key={involucrado.involucradoId} >
                                     <Table.Cell>{involucrado.tipoInvolucrado.nombre}</Table.Cell>
                                     <Table.Cell>{involucrado.nombreCompleto}</Table.Cell>
                                     <Table.Cell>{involucrado.tipoDocIdentidad.nombre}</Table.Cell>
                                     <Table.Cell>{involucrado.numeroDocIdentidad}</Table.Cell>
                                 </Table.Row>
                             ))
                             }                                
                         </Table.Body>
                     </Table> 
                 
                    }

                    </Segment>
                   
                    <table key='table02' width='55%' style={{display:'none'}}>
                        <caption style={ { 'captionSide': 'top' } }>Datos del caso </caption>
                        <tbody> 
                        <tr>
                            <th width='40%'>Tipo de Proceso</th>
                            <td width='60%'>
                                <Dropdown
                                    placeholder='Seleccionar'
                                    fluid
                                    selection
                                    options={tipoProcesoConst}
                                    />
                            </td>
                        </tr>
                        <tr>
                            <th>Distrito Judicial</th>
                            <td>
                                <Dropdown
                                    placeholder='Seleccionar'
                                    fluid
                                    selection
                                    options={distritoJudicial}
                                    />
                            </td>
                        </tr>
                        <tr>
                            <th>Fecha de Notificacion Entidad</th>
                            <td>
                                <DatePicketControl
                                    id='dtFechaNotifEntidad'
                                    name='dtFechaNotifEntidad' 
                                    changeHandler={(date) => this.setState({ dtFechaNotifEntidad : date }) }
                                    valor={ this.state.dtFechaNotifEntidad } />
                            </td>
                        </tr>
                       
                        <tr>
                            <th>Fecha de Presentacion Demanda</th>
                            <td>
                                <DatePicketControl
                                    id='dtFechaDemanda'
                                    name='dtFechaDemanda'
                                    changeHandler={(date) => this.setState({ dtFechaDemanda : date }) }
                                    valor={ this.state.dtFechaDemanda } />
                            </td>
                        </tr>
                        <tr>
                            <th>Fecha de Notificacion 1ra instancia</th>
                            <td>
                                <DatePicketControl
                                    id='dtFechaNotifPrimeraInst'
                                    name='dtFechaNotifPrimeraInst'
                                    changeHandler={(date) => this.setState({ dtFechaNotifPrimeraInst : date }) }
                                    valor={ this.state.dtFechaNotifPrimeraInst } />
                            </td>
                        </tr>
                        
                        <tr>
                            <th>Fecha de presentacion Apelacion</th>
                            <td>
                                <DatePicketControl
                                    id='dtFechaApelacion'
                                    name='dtFechaApelacion'
                                    changeHandler={(date) => this.setState({ dtFechaApelacion : date }) }
                                    valor={ this.state.dtFechaApelacion } />
                            </td>
                        </tr>
                        <tr>
                            <th>Fecha de Notificacion 2da Instancia</th>
                            <td><DatePicketControl
                                    id='dtFechaNotifSegundaInst'
                                    name='dtFechaNotifSegundaInst'
                                    changeHandler={(date) => this.setState({ dtFechaNotifSegundaInst : date }) }
                                    valor={ this.state.dtFechaNotifSegundaInst } />
                            </td>
                        </tr>
                        
                        <tr>
                            <th>Fecha de Presentacion RAC </th>
                            <td>
                                <DatePicketControl
                                    id='dtFechaPresentacionRAC'
                                    name='dtFechaNotifPresentacionRAC'
                                    changeHandler={(date) => this.setState({ dtFechaNotifPresentacionRAC : date }) }
                                    valor={ this.state.dtFechaNotifPresentacionRAC } />
                            </td>
                        </tr>

                        <tr>
                            <th>Fecha de inicio de Analisis</th>
                            <td>{casoFinal.fechaInicioAnalisis}</td>
                        </tr>
                         
                        </tbody>
                    </table>
                    
                    <Grid>
                        <Grid.Row>
                            <Grid.Column textAlign='center' >
                                <Link to={`/listaAnalisis`}> 
                                    <Button color='blue'>
                                        <Icon name="reply" />Volver
                                    </Button> 
                                </Link>
                                { (casoFinal.casoId !== 0 && !casoFinal.tipoResultado ) &&
                                    <Button color='red' type='submit'>
                                        Guardar
                                    </Button>                                
                                }
                                { (casoFinal.casoId !== 0 && !casoFinal.tipoResultado ) &&
                                    <Link to={`/analisis/`+this.state.casoFinal.casoId}> 
                                        <Button color='green' >
                                            Analizar Caso
                                        </Button> 
                                    </Link>
                                }
                            </Grid.Column> 
                        </Grid.Row>
                    </Grid>                
                
                </Form>

                </Container>

            );
    
        }
    }
  }
  
  export default WrappedDatosCaso